var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("日活用户")]),_vm._m(0),_c('div',{staticClass:"number"},[_vm._v(_vm._s(_vm.number))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgs"},[_c('img',{staticClass:"scroll",attrs:{"src":require("../../assets/images/user1.png")}}),_c('img',{attrs:{"src":require("../../assets/images/user2.png")}})])
}]

export { render, staticRenderFns }